import { Capacitor, registerPlugin } from '@capacitor/core';
import { Geolocation } from '@capacitor/geolocation';

const settings = registerPlugin('WiwDeviceSettings');
export const canOpenLocationSettings = () => Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios';
export const openLocationSettings = () => settings.openLocation();

export async function getDeviceLocation() {
  // Native Capacitor origins must not be rejected by the web secure-context
  // check. Android's TWA uses Chrome and its own permission delegation.
  if (Capacitor.isNativePlatform()) {
    try {
      let permission = await Geolocation.checkPermissions();
      if (['prompt', 'prompt-with-rationale'].includes(permission.coarseLocation)) {
        permission = await Geolocation.requestPermissions({ permissions: ['coarseLocation'] });
      }
      if (permission.coarseLocation !== 'granted') throw Object.assign(new Error('LOCATION_DENIED'), { code: 'LOCATION_DENIED' });
      return await Geolocation.getCurrentPosition({ enableHighAccuracy: false, timeout: 15000, maximumAge: 0 });
    } catch (error) {
      const code = error?.code;
      throw new Error(['LOCATION_DENIED', 'OS-PLUG-GLOC-0003'].includes(code) ? 'LOCATION_DENIED'
        : code === 'OS-PLUG-GLOC-0007' ? 'LOCATION_DISABLED'
        : code === 'OS-PLUG-GLOC-0010' ? 'LOCATION_TIMEOUT' : 'LOCATION_UNAVAILABLE');
    }
  }
  return new Promise((resolve, reject) => {
    if (!window.isSecureContext || !navigator.geolocation?.getCurrentPosition) {
      reject(new Error('LOCATION_UNAVAILABLE')); return;
    }
    // Invoke directly from the tap, before any await: Chrome/Safari own the
    // permission prompt. Do not pre-empt it with Permissions.query().
    navigator.geolocation.getCurrentPosition(resolve, error => reject(new Error(error.code === 1 ? 'LOCATION_DENIED'
      : error.code === 3 ? 'LOCATION_TIMEOUT' : 'LOCATION_UNAVAILABLE')),
    { enableHighAccuracy: false, timeout: 15000, maximumAge: 0 });
  });
}
